// Set or get a route to redirect the user to when the app starts, e.g. after a login flow
// The stored value is cleared out on read
const key = 'app_start_location';

export const setAppStartRoute = (path: string) => {
  localStorage.setItem(key, path);
};

export const getAppStartRoute = () => {
  const path = localStorage.getItem(key);
  localStorage.removeItem(key);
  return path;
};
